export const noticeDateValid = ({ context }) => !!context.noticeDate && !!context.effectiveDate;
export const noticePeriodComplete = ({ context }) => !!context.noticePeriodComplete;
export const settlementSigned = ({ context }) => !!context.settlementSigned;
//# sourceMappingURL=termination.js.map